import {
  Checkbox,
  FormControl,
  FormControlLabel,
  FormGroup,
  FormLabel,
  Radio,
  RadioGroup,
  Skeleton,
  TextField,
} from "@mui/material";
import { Box } from "@mui/system";
import { SmartAutoComplete } from "@nodeon/react-components";
import { Controller, useFormContext } from "react-hook-form";
import { useTranslation } from "react-i18next";
import { useDropdownOptions } from "../hooks/useDropdownOptions";
import { AtonsFaultSearchForm } from "../tabs/AtonsFaultSearchTab";
import { SharedFormProps } from "../WaterTrafficSignContainers/WaterTrafficSignStateForm";

export type FaultFormDefaultTypes = {
  faultState: string[];
  faultType: string | null;
  atonUnitIdOrName: string;
  atonUnitType: string | null;
  operational: string;
};

export const faultFormDefaults: FaultFormDefaultTypes = {
  faultState: [],
  faultType: null,
  atonUnitIdOrName: "",
  atonUnitType: null,
  operational: "",
};
// const testTilat = ["aiheeton", "avoin", "kirjattu", "korjattu", "peruttu"];
export const FaultForm = ({ isDisabled }: SharedFormProps): JSX.Element => {
  const { t } = useTranslation("faultSearch");
  const { register, control } = useFormContext<AtonsFaultSearchForm>();
  const { searchResult, isFetching } = useDropdownOptions();
  return (
    <Box
      sx={{
        display: "flex",
        flexDirection: "column",
        gap: "10px",
      }}
    >
      {/* <Typography>{t("fairwayReport:deviceIdOrName")}</Typography> */}

      <FormControl
        disabled={isDisabled}
        sx={{ display: "flex", flexDirection: "column" }}
      >
        <FormLabel>{t("state")}</FormLabel>
        <FormGroup sx={{ display: "flex", flexDirection: "row" }}>
          <Controller
            control={control}
            name="faultState"
            render={({ field }) => {
              if (isFetching) return <Skeleton />;
              return (
                <>
                  {/* <FormControlLabel
                    value=""
                    control={<Checkbox />}
                    label={t("faultSearch:kaikki")}
                  /> */}
                  {searchResult?.faultStates?.map((v) => (
                    <FormControlLabel
                      key={v}
                      value={v}
                      control={
                        <Checkbox
                          checked={field.value.some((ex) => ex === v)}
                          value={v}
                          onChange={(event, checked) => {
                            if (checked) {
                              field.onChange([
                                ...field.value,
                                event.target.value,
                              ]);
                            } else {
                              field.onChange(
                                field.value.filter(
                                  (value) => value !== event.target.value,
                                ),
                              );
                            }
                          }}
                        />
                      }
                      label={t(`faultState:${v}`)}
                    />
                  ))}
                </>
              );
            }}
          />
        </FormGroup>
      </FormControl>
      <SmartAutoComplete<AtonsFaultSearchForm, string, false>
        disabled={isDisabled}
        name="faultType"
        label={t("faultType")}
        options={searchResult?.faultTypes ?? []}
        controllerProps={{ control }}
      />
      <TextField
        disabled={isDisabled}
        {...register("atonUnitIdOrName", { required: false })}
        label={t("fairwayReport:deviceIdOrName")}
      />
      <SmartAutoComplete<AtonsFaultSearchForm, string, false>
        disabled={isDisabled}
        name="atonUnitType"
        label={t("atonType")}
        options={searchResult?.types ?? []}
        controllerProps={{ control }}
      />
      <FormControl
        disabled={isDisabled}
        sx={{ display: "flex", flexDirection: "column" }}
      >
        <FormLabel>{t("functionality")}</FormLabel>
        <Controller<AtonsFaultSearchForm>
          control={control}
          name="operational"
          render={({ field }) => (
            <RadioGroup
              sx={{ display: "flex", flexDirection: "row" }}
              {...field}
              // onChange={(_e, v) => field.onChange(v === "true")}
            >
              <FormControlLabel
                value=""
                control={<Radio />}
                label={t("kaikki")}
              />
              <FormControlLabel
                value="false"
                control={<Radio />}
                label={t("eiToimi")}
              />
              <FormControlLabel
                value="true"
                control={<Radio />}
                label={t("Toimii")}
              />
            </RadioGroup>
          )}
        />
      </FormControl>
    </Box>
  );
};
